import DocumentNode from './DocumentNode'

class BlockNode extends DocumentNode {}

BlockNode.isBlock = true

export default BlockNode
